import { render, staticRenderFns } from "./KeyResultModals.vue?vue&type=template&id=20fbe454&"
import script from "./KeyResultModals.vue?vue&type=script&lang=js&"
export * from "./KeyResultModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports